import React from "react";

export default function HomeTextLogo() {
  return (
    <React.Fragment>
      <svg
        width="172"
        height="43"
        viewBox="0 0 172 43"
        className="home-text-logo"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5732 13.1747L23.1483 18.5587H17.5732V18.066V13.1747Z"
          fill="#41E58F"
        />
        <path
          d="M22.1926 7.9729H9.28361C9.28361 7.97589 9.28361 7.97589 9.28361 7.97887H4.84028L4.76562 35.1226H10.5467V35.1167H22.1926C25.8267 35.1167 28.7829 32.1604 28.7829 28.5233V22.0703V21.0222V14.5662C28.7829 10.9321 25.8267 7.9729 22.1926 7.9729ZM23.1481 26.1553V29.5237V29.9238H10.5348V29.5237V26.1553V13.1747H17.5731L23.1481 18.5587V26.1553Z"
          fill="white"
        />
        <path
          d="M35.7529 34.9763H53.1052V29.9089H41.1787V24.2442H53.1052V19.1768H41.1787V13.6734H53.1052V8.36707H35.7529V34.9763Z"
          fill="white"
        />
        <path
          d="M66.3875 8.36707L58.2085 34.9763H63.8731L65.9067 28.3143H75.1636L77.1584 34.9763H82.9425L74.8023 8.36707H66.3875ZM67.1847 23.2469L70.4963 12.1982L73.8468 23.2469H67.1847Z"
          fill="white"
        />
        <path
          d="M94.0714 8.36707H88.4067V34.9763H103.845V29.67H94.0714V8.36707Z"
          fill="white"
        />
        <path
          d="M130.254 8.36707H123.312L115.294 19.9771V8.36707H109.51V34.9763H115.294V23.008L123.631 34.9763H130.574L120.481 21.6105L130.254 8.36707Z"
          fill="#41E58F"
        />
        <path
          d="M141.264 8.36707H135.599V34.9763H141.264V8.36707Z"
          fill="#41E58F"
        />
        <path
          d="M146.651 8.36707V13.9511H154.268V34.9763H159.933V13.9511H167.473V8.36707H146.651Z"
          fill="#41E58F"
        />
      </svg>
    </React.Fragment>
  );
}
